export default "__VITE_ASSET__BPdLzYG8__"